import type { GameResult } from '@/lib/games/engine/types';

/** Parse settlement JSON rows into typed game results. */
export function gameResultsFromSettlement(
  raw: Record<string, unknown>[] | null | undefined,
): GameResult[] {
  if (!raw?.length) return [];
  return raw.map((row) => {
    const net = row.netOwed ?? row.net;
    return {
      formatId: String(row.formatId ?? ''),
      label: String(row.label ?? ''),
      summary: String(row.summary ?? ''),
      netOwed: (typeof net === 'object' && net !== null ? net : {}) as Record<string, number>,
      winners: Array.isArray(row.winners) ? (row.winners as string[]) : undefined,
      standings: row.standings as GameResult['standings'],
      pointsAwarded: row.pointsAwarded as GameResult['pointsAwarded'],
      detail: row.detail as GameResult['detail'],
    };
  });
}
